<div class="p-d-flex p-flex-wrap gap-12">
  <ng-container *ngFor="let item of options">
    <div
      class="p-field-checkbox p-mb-0 radiobtn-box"
      (click)="handleClick(item)"
      [ngClass]="
        item.value === formCtrl.value ? 'selected' : 'non-selected'
      "
    >
      <p-radioButton
        [inputId]="'stari-' + item.value"
        name="stari"
        [value]="item.value"
        [formControl]="formCtrl"
      ></p-radioButton>
      <label style="cursor: pointer;" [for]="'vrsta-' + item.value">{{ item.label }}</label>
    </div>
  </ng-container>
</div>
